import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import ClinicalIntakeForm from './ClinicalIntakeForm';

/**
 * Protocol sub-tab: Source Documents — upload, validate, auto-populate admin & trial schema.
 */
const SourceDocumentsForm = ({ onSubmit, initialData, loading, isViewMode, onAdminDataPopulated }) => (
  <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0, overflowX: 'auto' }}>
    <Typography variant="h6" sx={{ mb: 0.5 }}>
      Source Documents
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Upload and validate source documents, then use Auto-populate to fill Administrative Info and Trial Schema configuration
      on their respective tabs. Parsing protocol intake continues on the Protocol Intake Form tab.
    </Typography>
    <Alert severity="info" sx={{ mb: 2 }}>
      Workflow: (1) Upload → (2) <strong>Validate Files</strong> → (3) <strong>Auto-populate</strong> → (4) Review
      Administrative Info tab → (5) Review &amp; save Trial Schema configuration on Protocol Intake Form → (6) Parse protocol intake.
    </Alert>
    <ClinicalIntakeForm
      onSubmit={onSubmit}
      initialData={initialData}
      loading={loading}
      isViewMode={isViewMode}
      documentsOnly
      onAdminDataPopulated={onAdminDataPopulated}
    />
  </Box>
);

export default SourceDocumentsForm;
